import Vue from 'vue';

export async function apartmentsOverviewInfoData(context: Vue) {
	const energyClass = await context.$locationService.fetchLocationEnergyClassByCatalogNumber(context.$route.params.locationCatalogNumber);

	return {
		energyClass
	};
}
